import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { WorkflowSummaryT } from '../../../types'

import { LABELS } from '../organizations'
import { USER } from '../users'

export const collection = 'workflowSummaries'

export const schema = new schemas.Entity(
  collection,
  {
    owner: USER.schema,
    editor: USER.schema,
    labels: LABELS.schema,
  },

  {
    processStrategy: (workflowSummary: WorkflowSummaryT) => ({
      ...workflowSummary,
      editor: workflowSummary.editor || null,
      editorId: workflowSummary.editorId || null,
    }),
  }
)

type FetchQueryType = {
  id: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: FetchQueryType) =>
    callApi(`${apiBase}/workflows/${id}/summary`, schema)
